import React from 'react';
import { TypedMemo } from '../../common/types';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import { FootagePanel } from './footage/FootagePanel';
import { LookPanel } from './LookPanel';
import { LyricsPanel } from './LyricsPanel';
import { TextPanel } from './TextPanel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The panel of the open tool (design b1, c, d, h). */
const SidePanelComponent: React.FC<{ className?: string }> = ({ className }) => {
  const { tool } = useMusicVideoEditor();
  return (
    <section className={className ?? styles.pane}>
      {tool === 'footage' && <FootagePanel />}
      {tool === 'text' && <TextPanel />}
      {tool === 'lyrics' && <LyricsPanel />}
      {tool === 'look' && <LookPanel />}
    </section>
  );
};

export const SidePanel = TypedMemo(SidePanelComponent);
